import { Link } from "gatsby";
import React from "react";

import logoChristieFinanceColoured from "../../../assets/img/logo-christie-finance-coloured.svg";
import { PhoneIcon } from "@heroicons/react/20/solid";

export const TopBanner = ({
  linkData,
}: {
  linkData: Queries.kontent_item_navigation_menu;
}) => {

  return (
    <div className="flex justify-between items-center w-full relative px-6 py-3">     
      <Link to="/" className="block" aria-label="Return to Home Page">
        <img
          src={logoChristieFinanceColoured}
          alt="Christie &amp; Finance Logo"
          className="w-auto h-12"
        />
      </Link>
      {/* <div className="max-w-2xl flex prose prose-brand border-2 border-red-500">
        <PhoneIcon className="size-32 text-red-500 p-5" />
        <p className="text-sm pr-5">We’re currently experiencing an issue with our phone lines, meaning our landline numbers are temporarily unavailable.
        If you need to reach the team, please contact us via our mobile numbers, which can be found via our <a href="/contact/our-people/">Team Directory</a>.
        <br />Thank you for your understanding while this is resolved.</p>
      </div> */}
      <div className="flex items-center justify-end flex-1 px-3 gap-x-6">
        <nav role="navigation" aria-label="Top Navigation">
          <ul className="flex items-center justify-end gap-2 text-sm">
            {linkData?.map((item, idx) => {
              const { name, linked_page, id } = item.elements;
              return (
                <li className="py-1" key={idx}>
                  <Link
                    to={linked_page?.value[0].url}
                    className="hover:bg-white/25 px-2 font-semibold hover:text-ice-600 hover:decoration-2 hover:underline-offset-2 first:pr-4 flex items-center gap-2"
                  >
                    {name.value}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};
